import React from "react";
import { createPortal } from "react-dom";
import { ApiLink } from "../../APILink/ApiLink";
import { money } from "./salesReconciliationModel";
import "../ReceivablesCRUD/ReceivablesForm.scss";
import "./ReconciliationPrint.scss";

const dateLabel = (value) => value ? String(value).slice(0, 10).split("-").reverse().join(".") : "—";
const euros = (value) => `${money(value)} EUR`;
const Row = ({ label, children }) => <div className="RFM__printTableRow" role="group" aria-label={label}><span>{label}</span><strong>{children}</strong></div>;
const PartyRow = ({ label, children }) => <div className="RFM__printPartyRow"><span>{label}</span><strong>{children}</strong></div>;

export default function ReconciliationPrint({ receipt, company }) {
  if (!receipt || !company) return null;
  const now = new Date();
  return createPortal(<div className="SRP__print RFM__print" style={{ display: "none" }} data-testid="reconciliation-print">
    <div className="RFM__printDoc">
      <div className="RFM__printHeader">
        <div className="RFM__printBrand">
          {company.CompanyLogo && <div className="RFM__printLogoWrap"><img src={ApiLink.PHOTO_URL + company.CompanyLogo} alt="Logo e kompanisë" className="RFM__printLogo" /></div>}
          <h2>{company.CompanyName}</h2><p>{company.Address || "—"}</p>
          <div className="RFM__printCompanyMeta"><span>NUI: {company.IdentificationNumber || "—"}</span><span>Telefon: {company.PhoneNumbers || "—"}</span></div>
        </div>
        <div className="RFM__printTitleBox"><h1>MANDAT BARAZIMI</h1><p>Dorëzimi i arkëtarit</p></div>
      </div>
      <div className="RFM__printMetaStrip">
        <div className="RFM__printMetaItem"><span>Nr. transferit</span><strong>TRS-{receipt.year}-{receipt.transfer.InvoiceNr}</strong></div>
        <div className="RFM__printMetaItem"><span>Periudha</span><strong>{dateLabel(receipt.from)} – {dateLabel(receipt.to)}</strong></div>
        <div className="RFM__printMetaItem"><span>Data e dokumentit</span><strong>{dateLabel(receipt.to)}</strong></div>
        <div className="RFM__printMetaItem"><span>Data e printimit</span><strong>{now.toLocaleDateString("sq-AL")}</strong></div>
      </div>
      <div className="RFM__printSectionTitle">Palët e dorëzimit</div>
      <div className="RFM__printPartyGrid">
        <div className="RFM__printPartyCard"><h3>Dorëzuesi / Arka burim</h3>
          <PartyRow label="Shitësi / Arkëtari">{receipt.seller}</PartyRow>
          <PartyRow label="Arka burim">{receipt.source.AccountName}</PartyRow>
        </div>
        <div className="RFM__printPartyCard"><h3>Pranuesi / Destinacioni</h3>
          <PartyRow label="Pranuar nga">{receipt.admin || "—"}</PartyRow>
          <PartyRow label="Llogaria e destinacionit">{receipt.destination.AccountName}</PartyRow>
        </div>
      </div>
      <div className="RFM__printSectionTitle">Përmbledhja e shitjeve të barazuara</div>
      <div className="RFM__printTable">
        <Row label="Kupona të ardhur">{receipt.couponCount}</Row>
        <Row label="Totali komplet">{euros(receipt.total)}</Row>
        <Row label="Cash nga shitjet">{euros(receipt.cash)}</Row>
        <Row label="Kartelë / Bankë">{euros(receipt.bank)}</Row>
        <Row label="Të tjera">{euros(receipt.other)}</Row>
      </div>
      <div className="RFM__printSectionTitle">Dorëzimi i parave</div>
      <div className="RFM__printTable">
        <Row label="Cash fillestar">{euros(receipt.opening)}</Row>
        <Row label="Cash që mbetet në arkë">{euros(receipt.keepOpening ? receipt.opening : 0)}</Row>
        <Row label="Shuma për dorëzim">{euros(receipt.due)}</Row>
        <Row label="Shuma e dorëzuar / Transferuar">{euros(receipt.transfer.Amount)}</Row>
        <Row label={receipt.difference < 0 ? "Mungesë" : receipt.difference > 0 ? "Tepricë" : "Diferenca"}>{euros(Math.abs(receipt.difference))}</Row>
      </div>
      <div className="RFM__printSignatureRow">
        <div className="RFM__printSignature"><span>Dorëzuesi / Arkëtari</span><div className="RFM__printSignatureLine" /></div>
        <div className="RFM__printSignature"><span>Pranuesi / Administratori</span><div className="RFM__printSignatureLine" /></div>
      </div>
      <div className="RFM__printFooterNote">Dokument i barazimit dhe dorëzimit të parave, i lidhur me transferin e ruajtur.</div>
      <div className="RFM__printCopyright">Copyright © {now.getFullYear()} Accountree. Të gjitha të drejtat e rezervuara.</div>
    </div>
  </div>, document.body);
}
